/**
 * ControlledAccordion React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material UI components
import ExpansionPanel from '@material-ui/core/ExpansionPanel';


class ControlledAccordion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            expandedPanelKey: props.defaultExpandedPanelKey
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.defaultExpandedPanelKey !== prevProps.defaultExpandedPanelKey) {
            this.setState({
                expandedPanelKey: this.props.defaultExpandedPanelKey
            });
        }
    }

    handlePanelChange(key) {
        this.setState({
            expandedPanelKey: key
        });
    }

    render() {
        const children = React.Children.map(this.props.children.filter(child => !!child), child =>
            child.type === ExpansionPanel ? React.cloneElement(child, {
                expanded: this.state.expandedPanelKey === child.key,
                onChange: (event, isExpanded) => this.handlePanelChange(isExpanded ? child.key : null)
            }) : child
        );
      
        return <div className={this.props.className}>{children}</div>;
    }
}

ControlledAccordion.propTypes = {
    defaultExpandedPanelKey: PropTypes.string
};

export default ControlledAccordion;